<template>
  <div class="container sv sv042">

    <breadcrumb-group :items="breadcrumbItems"/>

    <heading-one>教えて！みんなのローン活用術</heading-one>

    <p class="_mb-md-60">こんなときにあなたをサポート！au PAY スマートローンのいろいろな使い方をご紹介します。</p>

    <section id="section_01">

      <card-groups class="-image-top-list">
        <card-box router-name="sv053" class="-image-top">
          <card-header>
            <card-image class="-blue"><img src="@/assets/images/sv/sv053/thumb.jpg" class="img-fluid" alt=""></card-image>
            <h3 class="heading">“ちょっとだけ”がすごく助かる生活の工夫</h3>
          </card-header>
          <card-body>ローンの借り入れ理由として多いのが、実は「日々の生活費」なんです！</card-body>
        </card-box>
        <card-box router-name="sv008" class="-image-top">
          <card-header>
            <card-image class="-blue"><img src="@/assets/images/sv/sv008/thumb.jpg" class="img-fluid" alt=""></card-image>
            <h3 class="heading">急な飲み会･･･給料日前だけど参加したい！</h3>
          </card-header>
          <card-body>お誘いが多いのはうれしいけど、飲み会の回数が重なると結構な出費に…。</card-body>
        </card-box>
        <card-box router-name="sv006" class="-image-top">
          <card-header>
            <card-image class="-blue"><img src="@/assets/images/sv/sv006/thumb.jpg" class="img-fluid" alt=""></card-image>
            <h3 class="heading">結婚や出産…お祝いは突然やってくる?！</h3>
          </card-header>
          <card-body>「お祝い」続きで資金不足に…せっかくのお祝いを諦める？</card-body>
        </card-box>
        <card-box router-name="sv007" class="-image-top">
          <card-header>
            <card-image class="-blue"><img src="@/assets/images/sv/sv007/thumb.jpg" class="img-fluid" alt=""></card-image>
            <h3 class="heading">せっかくの卒業旅行…お金のことで諦めないで！</h3>
          </card-header>
          <card-body>楽しいはずの旅行…お金の都合で妥協したり、諦めかけたことってありませんか？</card-body>
        </card-box>
      </card-groups>

      <btngroup-single class="-margin-lg _mt-0">
        <btn-main class="-normal -lg" routerName="sv003">知っておきたい！ローンについてへ戻る</btn-main>
      </btngroup-single>

      <cv-box class="_mb-120 _mb-sm-60"/>

    </section>

  </div><!-- container -->
</template>

<script>
import HeadingOne from '../components/heading/HeadingOne'
import BtnMain from '../components/button/BtnMain'
import BtngroupSingle from '../components/button/BtngroupSingle'
import CardBox from '../components/card/CardBox'
import CardHeader from '../components/card/CardHeader'
import CardBody from '../components/card/CardBody'
import CardGroups from '../components/card/CardGroups'
import CardImage from '../components/card/CardImage'
import CvBox from '../components/box/CvBox'

export default {
  name: 'Sv-042',
  metaInfo: {
    title: '教えて！みんなのローン活用術｜知っておきたい！ローンについて',
    meta: [
      {name: 'description', content: 'こんなときにあなたをサポート！ローンのいろいろな使い方やみんなのローンの活用術をご紹介します。au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。'},
      {name: 'keywords', content: 'au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,おトク,ローン活用'}
    ]
  },
  components: {
    CvBox,
    BtnMain,
    BtngroupSingle,
    CardBody,
    CardImage,
    CardHeader,
    CardBox,
    CardGroups,
    HeadingOne
  },
  data () {
    return {
      breadcrumbItems: [{
        text: 'トップ',
        routerName: 'root'
      },
      {
        text: '知っておきたい！ローンについて',
        routerName: 'sv003'
      },
      {
        text: '教えて！みんなのローン活用術',
        active: true
      }
      ]
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Sv042.vue